// extracted by mini-css-extract-plugin
export default {"sections":"student_sections__U84X4","sectionItem":"student_sectionItem__544eC","openContent":"student_openContent__VYe1H"};